import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styles from '@utils/styles';
import breakpoints from '@repo/ui-components/breakpoints';

const GuaranteeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  max-width: 1280px;
  padding: 0;
  margin: 0 auto;

  @media screen and (min-width: ${breakpoints.lg}) {
    padding-top: 2.625rem;
  }

  @media screen and (min-width: ${breakpoints.md}) {
    padding-left: 1.625rem;
    padding-right: 1.625rem;
  }
`;

const ImageBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 1.625rem;

  @media screen and (min-width: ${breakpoints.lg}) {
    order: 2;
    width: 58%;
    margin-bottom: 0;
  }

  img {
    display: inline-block;
    height: auto;
    max-width: 100%;
  }
`;

const TextBlock = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  padding: 0 1.625rem;

  @media screen and (min-width: ${breakpoints.xl}) {
    padding-right: 6.875rem;
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    width: 42%;
  }

  @media screen and (min-width: ${breakpoints.md}) {
    padding-left: 0;
    max-width: 70ch;
  }

  .heading {
    font-size: ${styles.fontSize['4xl']};
    line-height: 1.15;
    letter-spacing: -0.5px;
    margin-bottom: 0.25em;
    font-weight: ${styles.fontWeight.extraBold};
    text-transform: uppercase;
    margin-top: 0;
    color: ${styles.colors.gray[700]};

    br {
      display: none;
      @media screen and (min-width: ${breakpoints.lg}) {
        display: initial;
      }
    }
  }

  p {
    font-size: ${styles.fontSize.base};
    line-height: 1.5;
    font-weight: ${styles.fontWeight.light};
    color: ${styles.colors.gray[700]};
    margin: 0px;
  }
`;

const GuaranteeBanner = () => {
  const data = useStaticQuery(graphql`
    query GuaranteeBannerQuery {
      allFile(filter: { name: { eq: "PDP_Warranty" } }) {
        nodes {
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, WEBP, AVIF]
              placeholder: BLURRED
              layout: CONSTRAINED
              width: 712
            )
          }
        }
      }
    }
  `);
  return (
    <GuaranteeWrapper>
      <ImageBlock>
        <GatsbyImage
          image={{
            ...getImage(data.allFile.nodes[0].childImageSharp),
            width: 712,
          }}
          alt="Lifetime guarantee"
        />
      </ImageBlock>
      <TextBlock>
        <div>
          <h3 className="heading">
            Lifetime <br />
            Guarantee
          </h3>
          <p>
            Kurgo prides itself in making superior quality products. There’s
            nothing more frustrating than buying a product that breaks. If,
            during your product’s lifetime, it does not function as it should
            due to a manufacturing defect, we will repair or replace your
            product free of charge. Hassle and worry free!
          </p>
        </div>
      </TextBlock>
    </GuaranteeWrapper>
  );
};

export default GuaranteeBanner;
